import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import { MdAccessTime, MdCall, MdEmail, MdLocationPin, MdWhatsapp } from "react-icons/md";

export default function ContactUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  const contacts = [
    {
      icon: <MdLocationPin size={24} />,
      title: "Location",
      value: "Dar es Salaam, Tanzania",
      onClick: () => window.open("https://maps.google.com/?q=Dar+es+Salaam,+Tanzania", "_blank"),
    },
    {
      icon: <MdCall size={24} />,
      title: "Phone",
      value: "+255 654 253 235",
      onClick: () => window.open("tel:+255654253235", "_blank"),
    },
    {
      icon: <MdEmail size={24} />,
      title: "Email",
      value: "sales@groupv.co.tz",
      onClick: () => window.open("mailto:sales@groupv.co.tz", "_blank"),
    },
    {
      icon: <MdWhatsapp size={24} />,
      title: "WhatsApp",
      value: "Chat with our team",
      onClick: () => window.open("https://wa.me/255654253235", "_blank"),
    },
  ];

  return (
    <div className="MainBodySection modern-contact-page">
      <div className="container py-5">
        <div
          className="modern-contact-head text-center"
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-offset="130"
        >
          <p className="modern-contact-eyebrow font-semi-bold">LET'S TALK</p>
          <h2 className="font-bold modern-contact-title">Contact Us</h2>
          <p className="modern-contact-subtitle">
            Reach Group V Limited for inquiries, quotations, or partnership opportunities. Our team is ready to
            support your next project.
          </p>
        </div>

        <div className="modern-contact-grid">
          {contacts.map((contact, index) => (
            <button
              key={index}
              className="modern-contact-card text-start"
              onClick={contact.onClick}
              data-aos="fade-up"
              data-aos-duration="900"
              data-aos-delay={index * 90}
            >
              <div className="modern-contact-icon">{contact.icon}</div>
              <p className="modern-contact-label font-semi-bold">{contact.title}</p>
              <h6 className="font-bold modern-contact-value text-muted">{contact.value}</h6>
            </button>
          ))}
        </div>

        <div
          className="modern-contact-hours mt-3"
          data-aos="fade-up"
          data-aos-duration="900"
          data-aos-delay="320"
        >
          <div className="modern-contact-hours-icon">
            <MdAccessTime size={24} />
          </div>
          <div>
            <p className="font-semi-bold modern-contact-hours-label">Business Hours</p>
            <h6 className="font-bold modern-contact-hours-value">Monday-Saturday, 8:00 AM - 6:00 PM</h6>
          </div>
        </div>
      </div>

      <style>{`
        .modern-contact-page {
          padding: 68px 0;
          background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
        }

        .modern-contact-head {
          max-width: 760px;
          margin: 0 auto 24px;
        }

        .modern-contact-eyebrow {
          font-size: 12px;
          letter-spacing: 1.2px;
          color: var(--secondaryColor);
          margin-bottom: 7px;
        }

        .modern-contact-title {
          font-size: clamp(30px, 4vw, 44px);
          margin-bottom: 8px;
        }

        .modern-contact-subtitle {
          margin: 0;
          font-size: 16px;
          line-height: 1.7;
          opacity: 0.88;
        }

        .modern-contact-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
          margin-bottom: 14px;
        }

        .modern-contact-card {
          width: 100%;
          border: 1px solid rgba(0, 29, 251, 0.1);
          border-radius: 16px;
          background: #ffffff;
          padding: 16px;
          box-shadow: var(--shadow1);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .modern-contact-card:hover {
          transform: translateY(-3px);
          box-shadow: var(--shadow3);
        }

        .modern-contact-icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: linear-gradient(145deg, var(--primaryColor), var(--secondaryColor));
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
        }

        .modern-contact-label {
          color: var(--primaryColor);
          font-size: 12px;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 4px;
        }

        .modern-contact-value {
          font-size: 17px;
          line-height: 1.45;
          margin: 0;
          color: var(--onSurfaceColor);
        }

        .modern-contact-hours {
          border-radius: 16px;
          border: 1px solid rgba(1, 155, 210, 0.2);
          background: linear-gradient(130deg, rgba(1, 155, 210, 0.08), rgba(0, 29, 251, 0.08));
          padding: 18px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .modern-contact-hours-icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: #ffffff;
          color: var(--secondaryColor);
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .modern-contact-hours-label {
          margin: 0;
          font-size: 12px;
          letter-spacing: 1px;
          text-transform: uppercase;
          opacity: 0.75;
        }

        .modern-contact-hours-value {
          margin: 0;
          font-size: 18px;
        }

        @media (max-width: 1199px) {
          .modern-contact-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 767px) {
          .modern-contact-page {
            padding: 52px 0;
          }

          .modern-contact-grid {
            grid-template-columns: 1fr;
          }

          .modern-contact-card,
          .modern-contact-hours {
            border-radius: 14px;
          }
        }
      `}</style>
    </div>
  );
}
